import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { FormGroupSelect, NestedFieldSet } from "components/formElements";
import {
  School,
  Graduation,
  PostGraduation,
  SkillDropdowns,
  CurrentCompany,
} from "components/formGroups";
import { getOptions, getMonthsOfExperience } from "util/library";
import Select from 'react-select';
import { getReactSelectOptions, CustomPlaceholder } from "util/library";

const LessThanOneYear = ({
  handleChange,
  graduationStreams,
  postGraduationStreams,
  monthsOfExperience,
  skills,
  ...rest
}) => (
  <Fragment>
    <NestedFieldSet legendText="Experience">
      {/*<FormGroupSelect*/}
      {/*  id="monthsOfExperience"*/}
      {/*  name="monthsOfExperience"*/}
      {/*  label="Months of Experience"*/}
      {/*  value={monthsOfExperience}*/}
      {/*  onChange={handleChange}*/}
      {/*  required*/}
      {/*  options={getOptions(*/}
      {/*    getMonthsOfExperience(),*/}
      {/*    "Select Months of Experience*"*/}
      {/*  )}*/}
      {/*      />*/}
            <div style={{ width: "50%", marginTop: "4px" }}>
                <Select
                    id="monthsOfExperience"
                    name="monthsOfExperience"
                    options={getReactSelectOptions(getMonthsOfExperience())} // format options like [{ value, label }]
                    value={getReactSelectOptions(getMonthsOfExperience()).find(
                        (opt) => opt.value === monthsOfExperience
                    )}
                    onChange={(selectedOption) => handleChange({
                        target: { name: 'monthsOfExperience', value: selectedOption?.value || '' }
                    })}
                    placeholder={<CustomPlaceholder text="Select Months of Experience" />}
                    styles={{
                        container: (base) => ({
                            ...base,
                            width: "95%",
                            marginLeft: "8px",
                        }),
                        control: (base) => ({
                            ...base,
                            height: "40px",
                            minHeight: "40px",
                            border: "1px solid grey",
                            borderRadius: "2px",
                        }),
                    }}
                    isClearable={true}
                />
            </div>

      <CurrentCompany handleChange={handleChange} {...rest} />
    </NestedFieldSet>

    <School handleChange={handleChange} {...rest} />
    <Graduation
      handleChange={handleChange}
      graduationStreams={graduationStreams}
      {...rest}
    />
    <PostGraduation
      handleChange={handleChange}
      postGraduationStreams={postGraduationStreams}
      {...rest}
    />
    <SkillDropdowns
      handleChange={handleChange}
      skills={skills}
      required
      {...rest}
    />
    {rest.noticePeriodFields}
  </Fragment>
);

LessThanOneYear.propTypes = {
  handleChange: PropTypes.func.isRequired,
  graduationStreams: PropTypes.array.isRequired,
  postGraduationStreams: PropTypes.array.isRequired,
  skills: PropTypes.array.isRequired,
};

export { LessThanOneYear };
